import { IJourneyResp } from '../../../../../services/journey.service';
import { Doctor, PrescriptionRenewalFormData } from '../../../../../entities/PrescriptionRenewal';

export default class PrescriptionRenewalModalModel {
  static canSubmitOrderForm(form: PrescriptionRenewalFormData): boolean {
    return Boolean(form.doctorId) && form.description.trim().length > 0;
  }

  static getDoctorsFromJourneys(journeys: IJourneyResp[]): Doctor[] {
    const doctorsById = new Map<string, Doctor>();
    journeys
      .flatMap(journey => journey.schedules || [])
      .filter(schedule => schedule.attendanceConfirmed && schedule.user?.doctor)
      .forEach(schedule => {
        const { id, name } = schedule.user;
        if (id) doctorsById.set(id, { id, name });
      });

    return Array.from(doctorsById.values()).sort((a, b) => a.name.localeCompare(b.name));
  }
}
